import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import banner from '../assets/study-notes-with-laptop-study.jpg';
import './Studiefinanciering.css';

const opleidingenLinks = [
  { to: '/brochures/hbo', label: 'HBO Opleidingen' },
  { to: '/brochures/master', label: 'Masteropleidingen' },
  { to: '/brochures/masterclasses', label: 'Masterclasses' },
  { to: '/studiefinanciering', label: 'Studiefinanciering', active: true }
];

const Studiefinanciering = () => {
  return (
    <div className="study-finance-page">
      <Navbar />

      <section className="study-finance-hero">
        <div className="study-finance-hero-inner">
          <div>
            <h1>Studiefinanciering</h1>
            <p>
              Investeer in je toekomst met passende financieringsopties voor jouw opleiding bij NLBA.
              Hier vind je alle informatie over de studiefinanciering via de Nationale Ontwikkelingsbank (NOB).
            </p>
            <a
              href="https://www.nob.sr/aanvraagformulier-studiefinanciering-suriname/"
              target="_blank"
              rel="noopener noreferrer"
              className="study-finance-nob-btn"
            >
              Ga naar NOB aanvraagpagina
            </a>
          </div>
          <img src={banner} alt="Studiefinanciering NLBA" />
        </div>
      </section>

      <section className="study-finance-content-section">
        <div className="study-finance-container">
          <div className="study-finance-layout">
            <aside className="study-finance-side-wrap">
              <p className="study-finance-side-label">Opleidingen</p>
              <ul className="study-finance-side-nav">
                {opleidingenLinks.map((item) => (
                  <li key={item.to}>
                    <Link to={item.to} className={`study-finance-side-link${item.active ? ' active' : ''}`}>
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </aside>

            <main>
              <article className="study-finance-panel">
                <h3>Studiefinanciering</h3>
                <p>
                  Door verder te studeren vergroot je je kansen op een beter en welvarend leven.
                  Studeren is een levenslange investering in tijd en geld. U kunt
                  studieleningen tegen lage rentes en met soepele voorwaarden krijgen.
                </p>
                <p>
                  Een universitaire opleiding of hoger beroepsonderwijs komt hiermee binnen bereik
                  van veel Surinamers. Ook voor personen die in Suriname zijn geboren en bezig zijn
                  met naturalisatie, zijn er mogelijkheden.
                </p>

                <div className="study-finance-info-grid">
                  <div className="study-finance-info-card">
                    <h4>Waarom studiefinanciering?</h4>
                    <p>Je kunt direct starten met je opleiding zonder volledige voorfinanciering.</p>
                  </div>
                  <div className="study-finance-info-card">
                    <h4>Voor wie?</h4>
                    <p>Voor studenten die willen investeren in professionele groei via HBO of masteronderwijs.</p>
                  </div>
                  <div className="study-finance-info-card">
                    <h4>Hoe aanvragen?</h4>
                    <p>Via de officiële NOB aanvraagpagina met de vereiste documenten en persoonlijke gegevens.</p>
                  </div>
                </div>

                <div className="study-finance-actions">
                  <a
                    href="https://www.nob.sr/aanvraagformulier-studiefinanciering-suriname/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="study-finance-primary-btn"
                  >
                    Vraag studiefinanciering aan
                  </a>
                  <Link to="/contact" className="study-finance-secondary-btn">
                    Eerst advies nodig? Neem contact op
                  </Link>
                </div>
              </article>
            </main>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Studiefinanciering;
